/* AceUtils.js */

"use strict";

const RegexUtils = require("./RegexUtils");

class AceUtils {
    static getRangeInstance(startRow, startColumn, endRow, endColumn) {
        let Range = ace.require("ace/range").Range;
        return new Range(startRow, startColumn, endRow, endColumn);
    }

    /**
     * Identifies regular expressions matching empty strings which cause infinite loop errors in
     *  ACE editor.
     *  If given regular expression is known to cause infinite loop errors, returns Error messages
     *      describing the cause.
     *  Else returns true.
     * @param regex
     * @returns {string|boolean}
     */
    static canEditorFindMatchesForRegex(regex) {
        // ends with * or ? allowing zero occurrences of given regex
        let canFindMatches = this.endsWithQuantifierAllowingEmptyStringMatches(regex);
        if (!canFindMatches) {
            return "quantifier_allows_empty_string_matches";
        }
        // ends with pipe
        if (
            regex.endsWith("|") ||
            (regex.endsWith("|)") && RegexUtils.isRegexWrappedWithParantheses(regex))
        ) {
            let lastPipeIndex = regex.lastIndexOf("|");
            canFindMatches = this._isLiteralCharInARegex(regex, "\\|", lastPipeIndex);
        }
        let indexOfDoublePipe = 0;
        while (
            canFindMatches &&
            (indexOfDoublePipe = regex.indexOf("||", indexOfDoublePipe + 1)) !== -1
        ) {
            canFindMatches = this._isLiteralCharInARegex(regex, "\\|", indexOfDoublePipe);
        }
        return canFindMatches ? canFindMatches : "ambiguous_pipe_reference";
    }

    static endsWithQuantifierAllowingEmptyStringMatches(regex) {
        let endsWithAsterisk = false;
        let lastCharIndexInRegex = regex.length - 1;
        let lastChar = regex.charAt(lastCharIndexInRegex);
        let regexWithoutEndingQuantifier = regex.substring(0, lastCharIndexInRegex);

        if (lastChar === "*" || lastChar === "?") {
            if (
                lastCharIndexInRegex === 1 ||
                regexWithoutEndingQuantifier === "\\*" ||
                regexWithoutEndingQuantifier === "\\?"
            ) {
                endsWithAsterisk = true;
            } else if (RegexUtils.isRegexWrappedWithParantheses(regexWithoutEndingQuantifier)) {
                endsWithAsterisk = !this._isLiteralCharInARegex(
                    regex,
                    "(\\*|\\?)",
                    lastCharIndexInRegex
                );
            }
        }
        return !endsWithAsterisk;
    }

    static getTokenizerInstance(rules) {
        let Tokenizer = ace.require("ace/tokenizer").Tokenizer;
        return new Tokenizer(rules);
    }

    static _isLiteralCharInARegex(inputString, searchChar, searchCharIndex) {
        let canFindMatches = true;
        let searchRegexObj = new RegExp(
            "(?<forwardslash>(\\\\)*)(?<searchCharGroup>" + searchChar + ")",
            "g"
        );
        let searchCharMatch;
        while (canFindMatches && (searchCharMatch = searchRegexObj.exec(inputString)) !== null) {
            if (
                searchCharMatch.index + searchCharMatch[0].length - 1 === searchCharIndex &&
                searchCharMatch.groups.forwardslash.length % 2 === 0
            ) {
                canFindMatches = false;
            }
        }
        return canFindMatches;
    }

    static comparePoints(p1, p2) {
        let Range = ace.require("ace/range").Range;
        return Range.comparePoints(p1, p2);
    }
}

module.exports = AceUtils;
